import React, { useMemo } from 'react'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetConnectionLink } from 'utils/hooks/useGetConnectionLink'
import { Button, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { ROUTES } from 'constants/routes'
import { useParams } from 'react-router'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const CreateAccountButton = ({ bulkAccountCreationAllowed }) => {
  const pathGen = useGeneratePathI18n()
  const { networkType } = useParams()
  const { t } = useTranslation(['services'])
  const connectionLink = useGetConnectionLink(networkType)
  const breakpoints = useBreakpoint()

  const buttonSize = useMemo(() => {
    switch (true) {
      case breakpoints.md:
        return 'm'
      case breakpoints.fbs:
        return 's'
      default:
        return 's'
    }
  }, [breakpoints])

  return (
    <>
      <Button
        align={'left'}
        startIcon={<Icon name={'plus'} />}
        variant={'primary'}
        size={buttonSize}
        fullWidth
        component={Link}
        to={pathGen(connectionLink, { networkType })}
      >
        <>
          {t('services::account_list.add_new_account', {
            context: networkType,
          })}
        </>
      </Button>

      {bulkAccountCreationAllowed && (
        <Button
          align={'left'}
          noWrap
          size={buttonSize}
          grey
          fullWidth
          startIcon={<Icon name={'plus'} />}
          component={Link}
          variant={'secondary'}
          to={pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT_MULTIREGISTER, {
            networkType,
          })}
        >
          {t('services::account_list.add_multiple_accounts')}
        </Button>
      )}
    </>
  )
}

export default CreateAccountButton

CreateAccountButton.propTypes = {
  networkId: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  bulkAccountCreationAllowed: PropTypes.bool,
}
